import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { OBJECT_DETECTION_OPTIONS } from "../constants/object_detection_options"

export default class extends Controller {
  static targets = ["labelsSelect"]

  declare readonly labelsSelectTarget: HTMLSelectElement
  private tomSelect: TomSelect | null = null

  connect(): void {
    this.initializeTomSelect()
  }

  private initializeTomSelect(): void {
    // Get initial values from the select element
    const initialValues = Array.from(this.labelsSelectTarget.selectedOptions).map(option => ({
      value: option.value,
      text: option.text
    }))

    this.tomSelect = new TomSelect(this.labelsSelectTarget, {
      plugins: ['remove_button'],
      maxItems: null,
      valueField: 'value',
      labelField: 'text',
      searchField: ['text'],
      options: OBJECT_DETECTION_OPTIONS,
      items: initialValues.map(v => v.value)
    })
  }
} 